import { render, staticRenderFns } from "./AttributeExternalLink.vue?vue&type=template&id=5ce09375"
import script from "./AttributeExternalLink.vue?vue&type=script&lang=js"
export * from "./AttributeExternalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports